import {AfterViewInit, Component, forwardRef, OnInit} from '@angular/core';
import fa from '../../../../assets/data/fa';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from "@angular/forms";

export class IconPickerModel {
  icon: string;
  unicode: string;

  constructor(icon?: string, unicode?: string) {
    this.icon = icon;
    this.unicode = unicode;
  }
}

@Component({
  selector: 'kis-icon-picker',
  templateUrl: './icon-picker.component.html',
  styleUrls: ['./icon-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => IconPickerComponent),
      multi: true
    }
  ]
})
export class IconPickerComponent implements OnInit, AfterViewInit, ControlValueAccessor {

  /** Icon search query */
  query: string;

  readonly QUERY_LIMIT = 15;

  /** Icons filtered */
  get icons(): string[] {
    if (this.query) {
      let foundIcons: string[] = [];
      for (const icon of fa.icons) {
        if (icon.startsWith(this.query)) {
          foundIcons.push(icon);
        }
        if (foundIcons.length === this.QUERY_LIMIT) {
          break;
        }
      }
      if (foundIcons.length < this.QUERY_LIMIT) {
        for (const icon of fa.icons) {
          if (icon.includes(this.query.toLowerCase()) && !icon.startsWith(this.query)) {
            foundIcons.push(icon);
          }
          if (foundIcons.length === this.QUERY_LIMIT) {
            break;
          }
        }
      }
      return foundIcons;
    } else {
      return this.DEFAULT_ICONS;
    }
  }

  /** Current selected icon */
  private _selectedIcon: string;

  get selectedIcon(): string {
    return this._selectedIcon;
  }

  set selectedIcon(icon: string) {

    if (icon) {

      this._selectedIcon = icon;
      if (!this.viewInit) {
        this.query = icon?.slice(3).split('-')[0];
      }

      const iconElement = document.querySelector(`.${icon}`);
      const iconChar = window.getComputedStyle(
        iconElement, ':before' // Add the ':before' to get the pseudo element
      )?.content?.replace(/['"]/g, '');
      const unicode = iconChar?.charCodeAt(0).toString(16);

      this.propagateChange(new IconPickerModel(icon, unicode));
    }
  }

  /** Propagate change to form control */
  propagateChange = (_: IconPickerModel) => {};

  /** View has initialized? */
  viewInit = false;

  readonly DEFAULT_ICONS = [
    'arrow-alt-circle-up',
    'arrow-circle-down',
    'asterisk',
    'at',
    'ban',
    'bell',
    'bell-slash',
    'bolt',
    'calendar',
    'camera',
    'cart-plus',
    'clock',
    'eye',
    'laptop',
    'key',
  ];

  constructor() {
  }

  ngOnInit(): void {
  }

  ngAfterViewInit(): void {
    this.viewInit = true;
  }

  /** Form control on change listener */
  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  /** Form control on touch listener */
  registerOnTouched(fn: any): void {
  }

  /** form control input */
  writeValue(obj: IconPickerModel): void {
    if (obj !== undefined) {
      this.selectedIcon = obj.icon;
    }
  }

}
